import { createSlice } from "@reduxjs/toolkit";
import {
  cpDashboard, cpListNotifications, cpMarkNotificationRead,
  cpListDocuments, cpAddDocument, cpDeleteDocument,
  cpListResources, cpListFeedback, cpSubmitFeedback,
  cpListPractice, cpRunPractice, cpGetProfile,
} from "../actions/candidate-portal-actions";

const initialState = {
  dashboard: null,
  notifications: [],
  documents: [],
  resources: [],
  feedback: [],
  practice: [],
  profile: null,
  loading: {},
  error: null,
};

const setLoading = (state, key, val) => { state.loading[key] = val; };

const slice = createSlice({
  name: "candidatePortal",
  initialState,
  reducers: {},
  extraReducers: (b) => {
    b.addCase(cpDashboard.pending, (s) => setLoading(s, "dashboard", true))
     .addCase(cpDashboard.fulfilled, (s, a) => { setLoading(s, "dashboard", false); s.dashboard = a.payload; })
     .addCase(cpDashboard.rejected, (s, a) => { setLoading(s, "dashboard", false); s.error = a.payload; })

     .addCase(cpListNotifications.pending, (s) => setLoading(s, "notifications", true))
     .addCase(cpListNotifications.fulfilled, (s, a) => { setLoading(s, "notifications", false); s.notifications = a.payload || []; })
     .addCase(cpListNotifications.rejected, (s, a) => { setLoading(s, "notifications", false); s.error = a.payload; })
     .addCase(cpMarkNotificationRead.fulfilled, (s, a) => {
        const updated = a.payload;
        if (updated) s.notifications = s.notifications.map(n => n.id === updated.id ? updated : n);
     })

     .addCase(cpListDocuments.fulfilled, (s, a) => { s.documents = a.payload || []; })
     .addCase(cpAddDocument.fulfilled, (s, a) => { if (a.payload) s.documents = [a.payload, ...s.documents]; })
     .addCase(cpDeleteDocument.fulfilled, (s) => {})

     .addCase(cpListResources.fulfilled, (s, a) => { s.resources = a.payload || []; })

     .addCase(cpListFeedback.fulfilled, (s, a) => { s.feedback = a.payload || []; })
     .addCase(cpSubmitFeedback.fulfilled, (s, a) => { if (a.payload) s.feedback = [a.payload, ...s.feedback]; })

     .addCase(cpListPractice.fulfilled, (s, a) => { s.practice = a.payload || []; })
     .addCase(cpRunPractice.fulfilled, (s, a) => { if (a.payload) s.practice = [a.payload, ...s.practice]; })

     .addCase(cpGetProfile.fulfilled, (s, a) => { s.profile = a.payload; });
  },
});

const candidatePortalSliceReducer = slice.reducer;
export default candidatePortalSliceReducer;
